import { type InfiniteData, useInfiniteQuery } from '@tanstack/react-query';

import { type GetEligibleCreditReversalOrdersResponse, getEligibleCreditReversals } from '~/services/OrdersService';

export const creditReversalQueryKeys = {
  all: ['creditReversals'] as const,
  lists: () => [...creditReversalQueryKeys.all, 'list'] as const,
  infinite: (userId: string, limit: number) => [...creditReversalQueryKeys.lists(), userId, limit] as const,
};

const DEFAULT_LIMIT = 10;

export function useGetEligibleCreditReversals(userId: string, limit = DEFAULT_LIMIT, enabled = true) {
  return useInfiniteQuery<
    GetEligibleCreditReversalOrdersResponse,
    Error,
    InfiniteData<GetEligibleCreditReversalOrdersResponse, number>,
    ReadonlyArray<unknown>,
    number
  >({
    queryKey: creditReversalQueryKeys.infinite(userId, limit),
    queryFn: ({ pageParam, signal }) => getEligibleCreditReversals(userId, limit, pageParam, signal),
    getNextPageParam: (lastPage) => (lastPage.hasMore ? lastPage.nextOrderOffset : undefined),
    initialPageParam: 0,
    enabled: !!userId && enabled,
  });
}
